var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneMob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 22,
    viewBox: "0 0 17 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.82271 13.1368C3.84236 13.1681 3.86201 13.1968 3.88072 13.2281C3.89943 13.2585 3.91627 13.2898 3.93592 13.3211C7.40964 18.9565 13.4084 22.272 14.5199 20.539L15.9242 18.0626C16.0411 17.8513 16.0215 17.5931 15.8746 17.3539C15.8727 17.3513 15.8633 17.3435 15.8596 17.3383C15.6641 16.9827 15.4854 16.9714 14.4591 16.341C13.9267 15.9688 13.3598 15.5645 12.9856 15.2593C12.6226 14.9654 12.1033 14.948 11.8058 15.2158L11.2277 15.7471C11.0303 15.9279 10.7589 16.0288 10.483 16.0236C9.65124 16.0105 8.05892 13.9228 7.17201 12.6359C6.92128 12.2707 6.72201 11.9647 6.60693 11.7777C6.4928 11.5908 6.30943 11.2769 6.09705 10.8908C5.35142 9.52913 4.21845 7.19707 4.62636 6.52319C4.76108 6.29886 4.9931 6.13278 5.25973 6.06583L6.04466 5.86932C6.44321 5.76584 6.68926 5.34065 6.60039 4.90067C6.50683 4.44591 6.41889 3.78768 6.34217 3.17206C6.27668 2.03125 6.35527 1.88169 6.12512 1.54519C6.12325 1.5391 6.12044 1.5278 6.11857 1.52519C5.97076 1.28607 5.74061 1.14086 5.4852 1.12695L2.47645 1C0.302209 1.01478 0.351794 7.50488 3.82271 13.1368Z",
    stroke: "#999999",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneMob);
export default __webpack_public_path__ + "static/media/phoneMob.4267c71ae79108f7bbfdb42151557f80.svg";
export { ForwardRef as ReactComponent };